import './MainContentAreaAll.css';
import { Link } from 'react-router-dom';
import React  ,{useState,setstate} from 'react'
function MphasisJobComponent(props){ 
    return(
       <div className="ExperienceMainLayout">   
       <br /> 
        <div class="card">
            <div class="card-footer" style={{height:"50px"}}>
            <span className="ExperienceCardFooter-Previous"><Link onClick={() => props.handlechange('Infosys')}>Previous</Link></span>
            <span className="ExperienceCardFooter"><Link onClick={() => props.handlechange('Synechron')}>Next</Link></span>
            </div>
           <h5 class="card-header">Mphasis, Columbus OH	
                              <br/>Apr 2020 – Sep 2020
                              <br/>Full Stack.Net Developer
          </h5>
           <div class="card-body">
           <h3 style={{textDecoration:"underline"}}>Roles And Responsibilities</h3>
           -Works on the old website which is visible to the Chase Employee and simple users interface so people can understand the work process in the Financing Sector.<br/>
           -Worked on API Use C# to make Classes for Data Structure and Created Classes and Method to Do Crud Operation Using Latest Microsoft Software SDK 3.1 .<br/>
           -Also Use VS2019 and SSMS 2018 with SQL server 2019 and use migration to create existing Database.<br/>
           -Use Bootstrap to Design UI Part and Bid API to UI Using Javascript FrameWork Angular .<br/>
           -Use the Java Script to convert old VB Scripting to Java Script for Chrome Compatibility..<br/>
           -Also Modify existing VB script Functionality As per Business Requirement Change and Cline Need.<br/>
           -Also Use IIS 7 to host existing Server Side App Use Inetpub to host Classic Asp Project .<br/>
           -Works closely with the with client and other team members to understand business needs and do Business Analysts for Understanding the Application Flow .<br/>
           -Works closely with the EQA team to ensure the Quality of the Delivery..<br/>
           -Works on the Jira to Create a Task for Team Member .<br/>
           -Did Testing on Web Pages and Find Issue and Resolve Them .<br/>
           -Involving in CICD flow for every release work and planning for new task.<br/>
           -Find The Bug and Error on Pages Which Is Left Over from Other developer .<br/>
           -Work Mostly With Asp Pages and VB Script <br/>
           -Used to work on task assigned on Jira Dashboard and Update the Workflow Daily Basics Also Create a Task for Team Also <br/>
           -Participating in daily scrums and helps following the Agile process.<br/>
           -Working with Git/github as the source for version control and project / issue management.<br/>
           -Working with API to create Back End Part for Migration of Application to new Technology like Angular <br/>
           -Created a unit test With More than 90% Code Coverage So Application Become Bug Free<br/>
           -Work SQL Testing and Create test Script for all Module of existing Application<br/>
           -Also involved in Problem Solving after Production Release of Application and Did Test after Release and if there is any Error Solved Them <br/>
           -Create Log Functionality for Old Application and Make Module to Save Log Data in SQL <br/>
           -Did Code review for all other Developer Pull request <br/>
           -Also Handled Daily Scrum Meeting and Take Feedback for Other Team Member <br/>
           -Worked on SQL database created a Stored Procedure and Function and Also Modify the existing Stored Procedure As Per client Need<br/>
           -Used net core 3.1  to create api and also used net core to Create Xunit Test Cases For Api <br/>
           -Use Entity FrameWork Code First Approach In Api project <br/>
           -Use Migration As well as To Create Database From Domain Level Classes<br/> 
            
           <h3 style={{textDecoration:"underline"}}>Environment</h3>
            Microsoft Visual Studio 2019, ASP.NET, C#, XML, JSON, JavaScript, jQuery, Agile and Scrum, Team Foundation Server 2010,Bit Bucket , Git For  Windows  ,Windows Server 2008 R2/2008 2010             
           </div>            
         </div>
       </div>
       
)
}
export default MphasisJobComponent